import * as React from 'react'
import classnames from 'classnames'

import styles from './styles.module.scss'

interface Props extends React.HTMLProps<HTMLInputElement> {
  checked: boolean
  labelClassName?: string
  labelText: string
}

export const Checkbox: React.FC<Props> = ({
  checked,
  className,
  labelClassName,
  labelText,
  ...rest
}) => {
  const inputClassName = classnames(styles.input, className)
  const id = rest.id || rest.name

  return (
    <label>
      <input checked={checked} className={inputClassName} id={id} type="checkbox" {...rest} />

      <div className={styles.label}>
        <span className={labelClassName}>{labelText}</span>
      </div>
    </label>
  )
}
